/**
 * selectOptions.ts — açılır listeler kayıttaki değeri ASLA gizlemez (rota 2.9)
 *
 * Sorun tek cümleyle: `<select>` bir değeri gösterebilmek için o değerin
 * seçenekler arasında bulunmasını şart koşar. Liste daraltılmışsa ya da kolonda
 * listede olmayan bir değer varsa, React kontrollü `select`in değeri `''`e düşer
 * ve ekranda ilk seçenek ("Seçiniz") görünür — alan BOŞ sanılır. Veri kaybı
 * olmaz (`onChange` tetiklenmez, `formData` değeri tutar) ama ekran yalan söyler:
 * kullanıcı alanın silindiğini sanır, düzeltmeye çalışır.
 *
 * Bu sınıf üç kez ayrı ayrı bulundu ve her seferinde tek bir çağrı noktasında
 * yamandı:
 *   1.21 — kargo firması: kolonda listede olmayan bir kod
 *   2.3  — aktivite sonucu: `IPTAL` seçilebilir kümede yoktu (canlıda 5 aktivite)
 *   2.9  — fatura durumu: entegrasyon siparişinde `IPTAL` koşulsuz siliniyordu
 *          (canlıda 67 sipariş) — üstüne adres açılır listeleri
 *
 * Üçüncüsünde kural merkeze alındı. Kural şu: **listeyi daraltmak serbest,
 * kayıttaki değeri düşürmek yasak.** Doğru kalıbın örneği `OrderStatusCard`'ın
 * `orderTypeOptions`'ıydı; oradaki fikir buraya taşındı.
 *
 * Eklenen seçenek listenin SONUNA konur: liste sırası (2.2/2.3'te eşdeğerlik
 * ölçülen şey) bozulmasın, istisna göze çarpsın.
 */

export interface Secenek {
  value: string;
  label: string;
}

/**
 * `{ value, label }` listesi — kayıttaki değer eksikse sona eklenir.
 *
 * @param secenekler Gösterilecek liste (daraltılmış olabilir)
 * @param mevcut     Kayıtta duran değer
 * @param etiketle   Eksik değerin etiketi; verilmezse ham değer basılır
 *                   (rota 1.21 dersi: bilinmeyen değer gizlenmez, kendisi görünür)
 */
export const degerFarkindaSecenekler = (
  secenekler: readonly Secenek[],
  mevcut?: string | null,
  etiketle?: (deger: string) => string
): Secenek[] => {
  const liste = secenekler as Secenek[];
  if (!mevcut || liste.some((s) => s.value === mevcut)) return liste;
  return [...liste, { value: mevcut, label: etiketle ? etiketle(mevcut) : mevcut }];
};

/**
 * Düz metin listesi (il, ilçe gibi) — kayıttaki değer eksikse sona eklenir.
 * `degerFarkindaSecenekler`'in aynısı, `{value,label}` sarmalayıcısı olmadan.
 */
export const degerFarkindaListe = (
  liste: readonly string[],
  mevcut?: string | null
): string[] => {
  const kopya = liste as string[];
  if (!mevcut || kopya.includes(mevcut)) return kopya;
  return [...kopya, mevcut];
};
